import * as React from "react"
import PropTypes from "prop-types"
import { Select, TextAreaEdit } from "components-design-system"

const formTypes = [
  {
    form_view: "Global",
    form_section: "Protocol",
  },
  {
    form_view: "Global",
    form_section: "Results",
  },
  {
    form_view: "Global",
    form_section: "Study Details",
  },
  {
    form_view: "Global",
    form_section: "Delayed Results Certification",
  },
  {
    form_view: "Global",
    form_section: "Sponsor Trial Website",
  },
  {
    form_view: "CTG",
    form_section: "Protocol",
  },
  {
    form_view: "CTG",
    form_section: "Results",
  },
  {
    form_view: "CTG",
    form_section: "Delayed Results Certification",
  },
  {
    form_view: "EMA RWD",
    form_section: "Protocol",
  },
  {
    form_view: "CTIS",
    form_section: "Protocol",
  },
  {
    form_view: "JRCT",
    form_section: "Protocol",
  },
  {
    form_view: "JRCT",
    form_section: "Results",
  },
  {
    form_view: "EUDRACT",
    form_section: "Results",
  },
]

const FileTypeField = ({ value: valueProp, onChange: onChangeProp, disabled }) => {
  const [value, setValue] = React.useState()

  // set value from { form_view: string, form_section: string } to string[]
  React.useEffect(() => {
    if (valueProp) {
      setValue(
        valueProp
          .filter((reg) => reg.form_view.toLowerCase() !== "eupas")
          .map((valObj) => `${valObj.form_view} ${valObj.form_section}`)
      )
    }
  }, [valueProp])

  // set value from string[] to { form_view: string, form_section: string }[] and call onChangeProp
  const onChange = (val) => {
    const ObjVals = val.map((stringVal) =>
      formTypes.find((type) => `${type.form_view} ${type.form_section}` === stringVal)
    )
    onChangeProp(ObjVals)
    setValue(ObjVals)
  }

  return (
    <Select
      mode="multiple"
      value={value}
      onChange={onChange}
      options={formTypes.map((obj) => `${obj.form_view} ${obj.form_section}`)}
      disabled={disabled}
    />
  )
}

FileTypeField.propTypes = {}

export default FileTypeField
